var console = require("./logger.js");
var Oop = require("./oop.js");
//var $ = require("./jquery-1.11.2.mod.js");
var EventUtil = require("./eventutil.js");
var CallbackTable = require("./callbacktable.js");
var MessageProxy = require("./messageproxy.js");
var FrameProxy = require("./frameproxy.js");

function FrameMessageBroker () {

    this._messageCallbackTable = new CallbackTable();

    var me = this;

    this._messageCallbackWrapper = function (event) {

        //// for JQuery, use event.originalEvent
        //me._messageCallback(event.originalEvent);
        me._messageCallback(event);
    };
}
FrameMessageBroker.name = "FrameMessageBroker";

Oop.borrow(FrameMessageBroker, MessageProxy, [
    "setSenderId",
    "getSenderId",
    "_senderId",
    "onMessage",
    "oneMessage",
    "offMessage",
    "_message",
    "_messageCallbackTable",
    "_messageCallbackWrapper",
    "_doCallback"
]);

Oop.borrow(FrameMessageBroker, FrameProxy, [
    "_createMessageObject"
]);

FrameMessageBroker.prototype._message = function (before, after) {

    if (before === 0 && after > 0) {

        //$(window).on("message", this._messageCallbackWrapper);
        EventUtil.onEvent(window, "message", this._messageCallbackWrapper);

    } else if (after === 0 && before > 0) {

        //$(window).off("message", this._messageCallbackWrapper);
        EventUtil.offEvent(window, "message", this._messageCallbackWrapper);
    }
};

FrameMessageBroker.prototype._messageCallback = function (event) {

    if (event == null) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_messageCallback] Insufficient event info");
        return;
    }

    var messageObject = this._createMessageObject(event);

    if (messageObject == null ||
        messageObject.targetId == null ||
        messageObject.messageId == null ||
        messageObject.senderId == null) {

        return;
    }

    // this._doMessageCallback(messageObject, this);
    // By checking callback array before creating FrameProxy, we could reduce the creation of FrameProxy objects.
    // Therefore, we do not call ._doMessageCallback directly
    var callbackArray = this._messageCallbackTable.getCallbackArray(messageObject.messageId);

    if (callbackArray.length > 0) {

        var frameProxy = new FrameProxy();

        var targetInfo = frameProxy.getTargetInfo();

        targetInfo.targetId = messageObject.senderId;
        targetInfo.window = event.source;
        targetInfo.origin = (event.origin === "null" ? null : event.origin);

        frameProxy.setTargetInfo(targetInfo);

        frameProxy.setSenderId(this._senderId);

        this._doCallback(callbackArray, messageObject, frameProxy);
    }
};

module.exports = FrameMessageBroker;


